import { useAuth } from "oidc-react";
import { Redirect, Route } from "react-router-dom";

const AppRoute = ({ isAnonymous, children, ...rest }) => {
  const auth = useAuth();

  if (auth.isLoading) {
    return null;
  }

  const isAllowed = isAnonymous || (auth && auth.userData && !auth.userData.expired);

  return (
    <Route
      {...rest}
      render={({location}) =>
        isAllowed ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: location }
            }}
          />
        )
      }
    />
  );  
};

export default AppRoute;